__turbopack_context__.v({
  "profile-photo-container": "keLh4G_profile-photo-container",
  "profile-photo-container__badge": "keLh4G_profile-photo-container__badge",
  "profile-photo-container__button": "keLh4G_profile-photo-container__button",
});
